import { couponCodeStore } from "../coupon/coupon"
import { cartStore } from "@/stores/cart/cart";
import Identifier from "~/pages/checkout/sp/[identifier].vue";
import { encodeURL } from '~/utils/helper/cyoHelper.js';
import { getErrorData, getMethodType } from '~/utils/payment/paymentHelper.js';
import { affirmPayNow, afterPayNow, splititModal, payBankWire, payTelephone } from "~/utils/payment/gatewayHelper.js";

// import { paymentStore } from "../payment/payment"
import { getAddressData, getUserLocation, submitAddress, validateCheckoutCart } from "~/services/api/payment"


export default {

    changePayType(type) {
        
        this.setCartData({ data: null, pay_type: getMethodType(type) })
        return this.commitMutation('changePayType', type)

    },
    async changePayMode(type) {

        this.commitMutation('changePayType', false)
        this.setCartData({ data: null })
        this.remountgateway();
        await new Promise(resolve => setTimeout(resolve, 1000))
        return this.commitMutation('changePayMode', type)

    },
    resetPaymentData() {
        return this.$reset()
    },

    setLoaderStatus(status) {

        return this.commitMutation('setLoaderStatus', status)
    },
    setModalContent(msg) {

        return this.commitMutation('setModalContent', msg)
    },
    setModalStatus(status) {

        return this.commitMutation('setModalStatus', status)
    },

    async mountErrorModalV2(data) {
        
        this.setLoaderStatus(false);
        const errorData = getErrorData(data);

        this.setModalContent({ ...errorData });
        // throwSentryException()
        this.postError(errorData);
        if (errorData.showModal !== false) {
            this.setModalStatus(true)
            return;
        }

        this.errorOnClickModalEvent({ ...errorData });
    },

    async postError(data) {

        const identifier = this._route().params.identifier;

        try {
            const response = await $fetch(useCountryPath("/payment/error-log"), {
                method: "POST",
                body: {
                    error_type: data?.internalMsg,
                    identifier: identifier,
                    error_message: data?.message?.substring(0, 250),
                },
            });
        } catch (errors) {

            console.log("Error while posting error data", errors);
        }
    },

    errorOnClickModalEvent({ message, eventAction, redirect, showModal, clearQueryParams = false }) {
        const localePath = useLocalePath();
        const router = useRouter();
        const route = useRoute();
        
        if (eventAction === "redirect") {
            if (redirect.type === "name") {
                // return router.push(localePath({ name: redirect.path }));
                return window.location.href = localePath({ name: redirect.path });
            }
            if (redirect.type === "to") {
                // return router.push(localePath({ path: redirect.path }));
                return window.location.href = localePath({ path: redirect.path });
            }
        }

        if (eventAction === "reload") {
            let baseUrl = router.resolve({ path: route.path, query: { ...route.query } }).href;

            const disable_offer = route.query.disableOffer || null;
            const tax_exempt_id = route.query.tax_exempt_id || null;
            const parent_order_id = route.query.parent_order_id || null;

            if (
                [true, "true"].includes(disable_offer) ||
                !["", null, "null", false, "false", undefined, "undefined"].includes(
                    tax_exempt_id
                ) ||
                !["", null, "null", false, "false", undefined, "undefined"].includes(
                    parent_order_id
                )
            ) {
                baseUrl = router.resolve({
                    path: route.path,
                    query: {
                        disableOffer: disable_offer,
                        tax_exempt_id: tax_exempt_id,
                        parent_order_id: parent_order_id,
                    },
                }).href;
            }
            
            if(clearQueryParams){
                baseUrl = router.resolve({ path: route.path }).href;
            }

            window.history.replaceState({}, null, baseUrl);
            window.location.reload();
        }
        if (eventAction === "remount") {
            // alert(123)
            window.location.reload();
            this.remountgateway(); //not needed as we are reloading the page
        }
        window.location.reload();
        this.setModalContent({ message: '' });
        this.setModalStatus(false)
    },

    setProcessStatus(status) {
        return this.commitMutation('setProcessStatus', status)
    },

    async createCharge(method) {

        const route = useRoute();
        const router = useRouter();
        const localePath = useLocalePath();
        const storeCart = cartStore();
        const { $country } = useNuxtApp()
        const storeCoupon = couponCodeStore()
        let couponCode = storeCoupon.getCouponCode()

        const pay_type = this.getPayType()
        const pay_mode = this.getPayMode()


        this.setProcessStatus(true);
        // const curr_currency = storeCart.getCurrency();
        let payload = {
            // address_id:this.$store.getters.getAddressId, //need to set in store
            currency: $country.currency_sign, //need to set in store
            address_id: "",
            pay_mode: pay_mode,
            identifier: route.params.identifier,
        };

        const disable_offer = route.query.disableOffer || null;
        if (["true", true].includes(disable_offer)) {
            payload.disableOffer = true;
        }

        const tax_exempt_id = route.query.tax_exempt_id || null;
        if (
            !["", null, "null", false, "false", undefined, "undefined"].includes(
                tax_exempt_id
            )
        ) {
            payload.tax_exempt_id = tax_exempt_id;
        }

        const parent_order_id = route.query.parent_order_id || null;
        if (
            !["", null, "null", false, "false", undefined, "undefined"].includes(
                parent_order_id
            )
        ) {
            payload.parent_order_id = parent_order_id;
        }

        if( couponCode ){

            payload.coupon = couponCode;
        }
        


        payload = {
            ...payload,
            ...method.data,
        };

        if (pay_mode === "cod_juspay") {
            this.changePayType("juspay");
        }

        // console.log(pay_type.value, pay_mode.value)
        if (!pay_type || !pay_mode) {
            this.mountErrorModalV2({ errorType: "requirePaymentMode" });
            return;
        }

        const url = useCountryPath(
            "/checkout/order/store"
        );

        try {
            const payRes = await $fetch(url, {
                method: "POST",
                body: payload,
            });

            localStorage.setItem("order_detail", JSON.stringify(payRes));

            // need
            if (payRes.success) {
                if (payRes.data.payment_status === "incomplete_payment") {
                    await this.setCartData()
                    await this.remountgateway();
                    // window.location.reload();
                    this.setLoaderStatus(false);
                }
                if (payRes.data.payment_status === "complete_payment") {
                    router.push(localePath({ name: "checkout-thank-you" }));
                    storeCart.setCartCount();
                    // this.$store.dispatch('setCart') //need to set in store
                    // .then( () => this.$store.dispatch('getCartCount') ) //need to set in store
                }
            }

            this.setProcessStatus(false);

            return;
        } catch (error) {
            this.setProcessStatus(false);

            if (error.response?.status === 400) {
                const msg = error.response?._data?.errors;
                const error_msg = error.response?._data?.message;

                console.log(
                    "----------------------------------error.response",
                    error.response._data,
                    msg
                );

                if (msg === "duplicate_items") {
                    this.mountErrorModalV2({ errorType: "validateCart" });
                } else if (msg === "empty_cart") {
                    this.mountErrorModalV2({ errorType: "getProducts" });
                } else if (msg === "user_not_found") {
                    this.mountErrorModalV2({ errorType: "backendUserNotFound" });
                } else if (msg === "braintree_paypal_error") {
                    this.mountErrorModalV2({
                        errorType: "backendBraintreeError",
                        errorMessage: error_msg,
                    });
                } else if (msg === "braintree_ach_error") {
                    this.mountErrorModalV2({
                        errorType: "backendBraintreeError",
                        errorMessage: error_msg,
                    });
                } else if (msg === "coupon_error") {
                    this.mountErrorModalV2({
                        errorType: "invalidCoupon",
                        errorMessage: error_msg,
                    });
                } else if (msg === "juspay_error") {
                    this.mountErrorModalV2({
                        errorType: "juspayError",
                        errorMessage: error_msg,
                    });
                } else if (msg === "cod_juspay_error") {
                    this.mountErrorModalV2({
                        errorType: "juspayError",
                        errorMessage: error_msg,
                    });
                } else if (msg === "afterpay_error") {
                    this.mountErrorModalV2({
                        errorType: "afterPayError",
                        errorMessage: error_msg,
                    });
                } else if (msg === "stripeError") {
                    this.mountErrorModalV2({
                        errorType: "stripeError",
                        errorMessage: error_msg,
                    });
                } else if (msg === "klarna_stripe_error") {
                    this.mountErrorModalV2({
                        errorType: "klarna_stripe_error",
                        errorMessage: error_msg,
                    });
                }

                else if (msg === "Affirm_stripe_error") {
                    this.mountErrorModalV2({
                        errorType: "affirmStripeError",
                        errorMessage: error_msg,
                    });
                }

                return;
            }

            this.mountErrorModalV2({ errorType: "backendServerError" });
        }
    },
    setPaymentSkeleton(status) {
        return this.commitMutation('setPaymentSkeleton', status)
    },
    setGatewayComponentKey() {
        return this.commitMutation('setGatewayComponentKey')
    },
    setGatwayStatus(data) {
        return this.commitMutation('setGatwayStatus', data)
    },
    updateGateways() {
        const eligiblePaymentGateways = this.eligiblePaymentGateways();
        const gatwayStatus = this.getGatwayStatus();
        Object.entries(eligiblePaymentGateways).forEach(([key, value]) => {
            if (gatwayStatus[key] !== undefined && value === false) {
                gatwayStatus[key] = true;
            }
        });
        return this.commitMutation('setGatwayStatus', gatwayStatus)
    },
    remountgateway() {
        this.setPaymentSkeleton(true)
        nextTick(() => {

            setTimeout(() => {
                this.setPaymentSkeleton(false)
                this.setGatewayComponentKey()
                this.updateGateways()

                this.changePayType(false)
            }, 900)
        })
    },

    gatewayInitialized({ gateway }) {
        const gatwayStatus = this.getGatwayStatus();
        if (gatwayStatus[gateway] !== undefined) {
            gatwayStatus[gateway] = true;
        }
        return this.commitMutation('setGatwayStatus', gatwayStatus)
    },

    async setCreatePlanData(paymentMethod = null) {

        const route = useRoute();
        const storeCoupon = couponCodeStore()
        const cartData = this.getCartData();
        const pay_mode = this.getPayMode();
        const pay_type = this.getPayType();
        let couponCode = storeCoupon.getCouponCode()

        let planObject = {};

        planObject.amount = cartData.total_label;
        planObject.pay_mode = pay_mode;
        planObject.pay_type = await getMethodType(pay_type);
        planObject.payment_method = paymentMethod;
        planObject.identifier = route.params.identifier;

        if (["online_payment"].includes(pay_mode)) {
            planObject.amount = this.getSplitAmt();
        }
        const payload = {
            coupon: couponCode,
        };

        //send disableOffer if it exists in route query
        const disable_offer = route.query.disableOffer || null;
        if (["true", true].includes(disable_offer)) {
            payload.disableOffer = true;
        }

        const tax_exempt_id = route.query.tax_exempt_id || null;
        if (
            !["", null, "null", false, "false", undefined, "undefined"].includes(
                tax_exempt_id
            )
        ) {
            payload.tax_exempt_id = tax_exempt_id;
        }

        try {
            const res = await $fetch(
                useCountryPath("/checkout/createpaymentplan?" + encodeURL(payload)),
                {
                    method: "POST",
                    body: planObject,
                }
            );

            if (res.success !== undefined && res.success === true) {
                localStorage.setItem("paymentPlan", JSON.stringify(planObject));
                // return  res.data
                return this.commitMutation('setCreatePlanData', res.data)
            }
            this.mountErrorModalV2({ errorType: "getPaypalUserData" });

            return false;
        } catch (error) {
            if (error.response?.status === 400) {
                const error_msg = error.data.message;
                this.mountErrorModalV2({
                    errorType: "createPlanError",
                    errorMessage: error_msg,
                });
            }
        }
    },
    setSplitAmt(amt) {
        return this.commitMutation('setSplitAmt', amt)
    },
    async setPaypalClientToken() {
        const storeCoupon = couponCodeStore()
        let couponCode = storeCoupon.getCouponCode()
        const res = await $fetch(
            useCountryPath("/checkout/paypal/token?coupon=" + couponCode),
            {
                method: "POST",
            }
        );

        if (res.success === true && res.data?.paypal_token) {
            return res.data.paypal_token
        }

        this.mountErrorModalV2({ errorType: "getPaypalClientToken" });
        //
        return false;
    },

    checkSplitPayment() {
        const pay_mode = this.getPayMode();
        const cartData = this.getCartData();
        const payment_modes = this.getPaymentModes();
        const first_split_amount = this.getSplitAmt();

        if (pay_mode === "online_payment") {
            const minAmount = parseFloat(payment_modes.online_payment.amount);
            const maxAmount = parseFloat(
                (cartData.total_label * 0.98).toFixed()
            );

            const userAmount = parseFloat(first_split_amount);
            // console.log( minAmount, maxAmount, userAmount,  )
            if (userAmount >= minAmount && userAmount <= maxAmount) {
                return { status: true, msg: "success" };
            }

            return { status: false, msg: "amount do not match" };
        }

        return { status: true, msg: "success" };
    },

    async payNow() {

        const pay_type = this.getPayType()
        const pay_mode = this.getPayMode()

        // console.log(pay_type, pay_mode.value)
        if (!pay_type || !pay_mode) {
            this.mountErrorModalV2({ errorType: "requirePaymentMode" });
            return;
        }
        
        const { status: isAmountValid } = this.checkSplitPayment();
        // console.log('isAmountValid',isAmountValid )
        if (!isAmountValid) {
            return;
        }

        this.setLoaderStatus(true);

        if (pay_type === "stripe_card") {
            document.querySelector("#stripecardFormSubmitButton").click();
            return;
        }

        if (pay_type === "affirm_stripe") {
            document.querySelector("#stripeAffirmSubmitButton").click();
            return;
        }

        await this.setCreatePlanData();

        const createPlanData = this.getCreatePlanData()
        if (pay_type != "splitit") {
        }

        if (pay_mode === "cod_juspay") {
            this.changePayType("juspay");
        }

        

        if (createPlanData == undefined && createPlanData == null) {
            return;
        }

        if (pay_type === "credit_card") {
            // paypal_card.value.initiateCard(createPlanData)
            document.querySelector("#cardFormSubmitButton").click();
        }

        if (pay_type === "affirm") {
            affirmPayNow(createPlanData);
            // document.querySelector('#affirmSubmitButton').click()
        }

        if (pay_type === "afterpay") {
            afterPayNow(createPlanData);
            // document.querySelector('#affirmSubmitButton').click()
        }

        if (pay_type === "telephone") {
            payTelephone(createPlanData);
            // document.querySelector('#TelephoneSubmitButton').click()
        }

        if (pay_type === "bankwire") {
            payBankWire(createPlanData);
        }
        if (pay_type === "ach") {
            document.querySelector("#AchSubmitForm").click();
        }
        if (pay_type === "splitit") {
            // console.log(splitit.value.url, 'splitit.valuesplitit.valuesplitit.value')
            splititModal(createPlanData);
            // document.querySelector('#SpiltitSubmitButton').click()
        }
         if (pay_type === "klarna_stripe") {
            document.querySelector("#stripeKlarnaSubmitButton").click();

        }
    },

    async setAddressId(address_id) {
        this.commitMutation('setAddressId', address_id)
    },

    async setCartData(data) {

        const route = this._route()
        const router = useRouter()
        const localePath = useLocalePath()
        const storeCoupon = couponCodeStore()
        // const storePayment = paymentStore()

        let coupon = storeCoupon.getCouponCode()
        
        if (data && data?.coupon) {
            if (coupon != data.coupon) {
                coupon = data.coupon
            }
        }

        // Override coupon if provided in data
        // if (data?.coupon && coupon !== data.coupon) {
        //     coupon = data.coupon
        // }

        // Prepare request parameters
        // Use validatedIdentifier if provided (to avoid race condition with route updates)
        // Otherwise fall back to route params
        const identifier = route.params.identifier
        
        const params = {
            identifier: identifier,
            coupon,
            disableOffer: ['true', true].includes(route.query.disableOffer),
            tax_exempt_id: route.query.tax_exempt_id,
            pay_type: data?.pay_type,
        }
        if(route.query?.shared_from_pos){
            params.shared_from_pos = route.query.shared_from_pos
        }

        try {
            const response = await getAddressData(params)

            // Validate cart items
            if (response.data.items.length === 0 ||
                response.data.availability === 0 ||
                response.data.is_duplicate === 1) {

                // all errors messages are set by frontend based on error type
                return this.mountErrorModalV2({
                    errorType: "validateCart"
                });
            }

            // Update store state
            this.commitMutation('setCartData', response)
            this.commitMutation('setCartTotal', response.data)

            // if( response.data.address ){
            this.commitMutation('setAddressData', response.data.address)
            this.commitMutation('setGuestData', response.data.address)
            this.commitMutation('setIsAddressSet', response.data.is_address_set)
            // }
            if (response.data.payment_modes) {
                this.commitMutation('setPaymentModes', response.data.payment_modes)
            }


            // Handle coupon success
            if (response.data.coupon?.applied && response.data.coupon?.success) {
                storeCoupon.setCouponToStorage(coupon)
            }

            return response

        } catch (error) {
            
            if( error.response.status == 400 ){

                if( error.response.status == 400 && error.response._data?.errors == 'critical_error' ){
                    this.mountErrorModalV2({
                        errorType: 'backendServerError',
                        errorMessage: error.response._data?.message,
                    });
                }else if( error.response._data?.errors == 'empty_cart' ){
                    this.mountErrorModalV2({
                        errorType: 'getProducts',
                        errorMessage: error.response._data?.message,
                    });
                }else{

                    this.mountErrorModalV2({
                        errorType: 'getProducts',
                        errorMessage: error.response._data?.message,
                    });
                }

            }
            
            else{
                this.handleValidateCheckoutCartError(error)
            }
        }
    },

    async setUserLocation() {
        try {
            const locationData = await getUserLocation()

            if (locationData?.ipAddress) {
                this.commitMutation('setUserLocation', locationData)
            }

        } catch (error) {

            if (error.response.status == 400) {
                this.mountErrorModalV2({
                    errorType: "critical_error",
                    errorMessage: error.response._data.message,
                });
            }
            else{
                this.handleValidateCheckoutCartError(error)
            }

        }
    },

    async updateCountryCode(code) {
        this.commitMutation('updateCountryCode', code)
    },

    async updateCountry(code) {
        this.commitMutation('updateCountry', code)
    },

    async addressSubmit(payload) {
        const route = this._route()
        const localePath = useLocalePath()
        const { login } = useSanctumAuth()
        const user = useSanctumUser()
        const { $submitAddressGtag, $toast } = useNuxtApp()

        const data = payload.data
        data.identifier = route.params.identifier
        //  add identifier to data

        this.commitMutation('setErrorData', {})

        try {
            const response = await submitAddress(data)

            // Handle guest checkout vs user login
            if (!response.data.is_guest_checkout && !user?.value) {
                await this.handleUserLogin(data, route, localePath, login, $toast)
                await new Promise(resolve => setTimeout(resolve, 500)) 
            }

            // Handle successful submission
            this.handleSuccessfulSubmission(data, route, localePath, $submitAddressGtag, $toast)
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return { success: true }

        } catch (error) {
            this.handleSubmissionError(error)
        }
    },

    // Private helper methods
    handleUserLogin(data, route, localePath, login, $toast) {
        return login({ ...data, remember: true })
            .then(() => {
                $toast('success', 'Success!', 'Address saved successfully.')

                // setTimeout(() => {
                //     this.redirectToPayment(route, localePath)
                // }, 1500)
            })
    },

    handleSuccessfulSubmission(data, route, localePath, $submitAddressGtag, $toast) {
        $submitAddressGtag({ phone: '', email: data.email })
        $toast('success', 'Success!', 'Address saved successfully.')
        this.setCartData()
        // setTimeout(() => {
        //     this.redirectToPayment(route, localePath)
        // }, 1500)
    },

    // redirectToPayment(route, localePath) {
    //     this.commitMutation('resetAddressData')

    //     const queryParams = this.buildPaymentQueryParams(route)

    //     // if (Object.keys(queryParams).length > 0) {
    //     //     window.location.href = localePath({
    //     //         path: '/checkout/payment',
    //     //         query: queryParams
    //     //     })
    //     //     return
    //     // }

    //     this.setCartData()
    //     // this.setAddressData()
    // },

    buildPaymentQueryParams(route) {
        const params = {}

        const disableOffer = route.query.disableOffer
        const taxExemptId = route.query.tax_exempt_id
        const parentOrderId = route.query.parent_order_id

        if ([true, 'true'].includes(disableOffer)) {
            params.disableOffer = disableOffer
        }

        if (!['', null, 'null', false, 'false', undefined, 'undefined'].includes(taxExemptId)) {
            params.tax_exempt_id = taxExemptId
        }

        if (!['', null, 'null', false, 'false', undefined, 'undefined'].includes(parentOrderId)) {
            params.parent_order_id = parentOrderId
        }

        return params
    },

    handleSubmissionError(error) {
        if (error.status === 422) {
            this.commitMutation('setErrorData', error.data.errors)
        } else {
            console.error('Address submission error:', error)
            alert("Something went wrong. Please try again after some time or contact admin")
        }
    },

    async resetAddressData() {
        this.commitMutation('resetAddressData')
    },

    clearErrorByKey(key) {
        this.commitMutation('clearErrorByKey', key)
    },


    handleValidateCheckoutCartError(error) {

        this.mountErrorModalV2({
            errorType: "500",
            errorMessage: error.response._data.message,
        });
    
    },

    async validateCheckoutCart() {

        try{
            const currentIdentifier = this._route().params.identifier
            const router = this._router()
            const localePath = useLocalePath()
            const route = this._route()
            const shared_from_pos = this._route().query?.shared_from_pos

            // Call API to validate/clone cart
            // Backend handles all tracking via database (Shopify-like approach)
            // This is SSR-friendly and more reliable than localStorage
            const response = await validateCheckoutCart( currentIdentifier, shared_from_pos )

            const returnedIdentifier = response.data.identifier

            // If identifier changed (cart was cloned), update the URL
            if (returnedIdentifier !== currentIdentifier) {
                // Update URL without reloading the page (Shopify-like behavior)
                const newPath = localePath({ 
                    name: 'checkout-sp', 
                    params: { 
                        identifier: returnedIdentifier 
                    },
                    query: {
                        ...route.query,
                        shared_from_pos: shared_from_pos
                    }
                })
                
                // Replace current history entry to avoid back button issues
                // This ensures each user gets their own unique checkout session
                await router.replace(newPath)
                
                // Wait for Vue's reactivity system and browser to fully process the route change
                // This ensures other components get the updated identifier
                await nextTick()
                await new Promise(resolve => setTimeout(resolve, 500))
                
                return response
            }

            return response
        } catch (error) {
            console.error('error validateCheckoutCart', error)
            if( error.response?.status == 400 ){
                if( error.response._data?.errors == 'too_many_clone_attempts' ){
                    
                    this.mountErrorModalV2({
                        errorType: "too_many_clone_attempts",
                        errorMessage: error.response._data?.message,
                    });
                    return
                }
                this.mountErrorModalV2({
                    errorType: "validateCheckoutCartError",
                    errorMessage: error.response._data?.errors,
                });
            }
            else{
                this.handleValidateCheckoutCartError(error)
            }
        }
    },
}